import { takeLatest, select, cancel, put } from 'redux-saga/effects';
import size from 'lodash/size';

import * as providerUpcomingAppointments from '../requests/virtual-appointments-upcomming-req';
import * as providerHistoryAppointments from '../requests/virtual-appointments-history-req';
import {
  selectProviderHistoryAppointmentList,
  selectProviderHistoryCount,
  selectProviderHistoryPagination,
  selectProviderUpcomingAppointmentList,
  selectProviderUpcomingCount,
  selectProviderUpcomingPagination,
} from '../selectors';

const targetData = {
  [providerUpcomingAppointments.consts.LOAD_MORE]: {
    selectors: {
      pagination: selectProviderUpcomingPagination,
      list: selectProviderUpcomingAppointmentList,
      counter: selectProviderUpcomingCount,
    },
    fetch: providerUpcomingAppointments.paginationActions.send,
  },
  [providerHistoryAppointments.consts.LOAD_MORE]: {
    selectors: {
      pagination: selectProviderHistoryPagination,
      list: selectProviderHistoryAppointmentList,
      counter: selectProviderHistoryCount,
    },
    fetch: providerHistoryAppointments.paginationActions.send,
  },
};

function* loadMoreProviderAppointments({ type, payload }) {
  const { selectors, fetch } = targetData[type];
  const pagination = yield select(selectors.pagination);
  const counter = yield select(selectors.counter);
  const list = yield select(selectors.list);
  const listSize = size(list);

  if (counter <= listSize) {
    yield cancel();
  }

  yield put(fetch({ ...payload, ...pagination, offset: listSize }));
}

export default function* providerAppointmentListPagination() {
  yield takeLatest(
    [
      providerUpcomingAppointments.consts.LOAD_MORE,
      providerHistoryAppointments.consts.LOAD_MORE,
    ],
    loadMoreProviderAppointments,
  );
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/provider-appointment-list-pagination.js